import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { IonicModule } from '@ionic/angular';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { isPhoneNumberFeatureEnabled } from 'src/app/core/phone-number-feature';
import { APP_ROUTE_PATTERNS } from 'src/app/core/route-paths';

@Component({
  selector: 'app-self-service',
  templateUrl: './self-service.component.html',
  styleUrls: ['./self-service.component.scss'],
  imports: [HeaderComponent, IonicModule, RouterLink, RouterLinkActive, RouterOutlet, FooterComponent],
})
export class SelfServiceComponent {
  private route = inject(ActivatedRoute);
  public readonly showPhoneNumberFeature = isPhoneNumberFeatureEnabled;
  public readonly routePaths = APP_ROUTE_PATTERNS;

  constructor() {
    console.log('SelfServiceContainerComponent');
  }
}
